import React, { useEffect, useState } from 'react';
import Header from '../../Shared/Components/Header/Header';
import Card from '../../Shared/Components/Card/Card';

const DevStatus = () => {
    const [runtime, setRuntime] = useState(
        {
            Self: {
                status: "",
                data: {},
                tags: []
            },
            ApplicationDbContext: {
                status: "",
                data: {},
                tags: []
            },
            AzureServiceBus: {
                status: "",
                data: {},
                tags: []
            }
        }
    )

    const [gateway, setGateway] = useState(
        {
            Self: {
                status: "",
                data: {},
                tags: []
            },
            ApplicationDbContext: {
                status: "",
                data: {},
                tags: []
            },
            AzureServiceBus: {
                status: "",
                data: {},
                tags: []
            }
        }
    )

    // useEffect(() => {
    //     //let host = window.location.href;
    //     fetch(`https://content.${host}/readiness`)
    //         .then(response => response.json())
    //         .then(json => setRuntime(json.entries));
    //     fetch(`https://api.${host}/readiness`)
    //         .then(response => response.json())
    //         .then(json => setGateway(json.entries));
    // }, [])

    return (
        <>
            <Header heading="DevOps" icon="user" />
            <div className="container-fluid content">
                <Card title="Public api's">
                    <div className="row">
                        <div className="col-6">
                            <strong><p>API Gateway</p></strong>
                            <p>Self: {gateway.Self.status}</p>
                            <p>Application Db Context: {gateway.ApplicationDbContext.status}</p>
                            <p>Azure Service Bus: {gateway.AzureServiceBus.status}</p>
                        </div>
                        <div className="col-6">
                            <strong><p>Runtime environment</p></strong>
                            <p>Self: {runtime.Self.status}</p>
                            <p>Application Db Context: {runtime.ApplicationDbContext.status}</p>
                            <p>Azure Service Bus: {runtime.AzureServiceBus.status}</p>
                        </div>
                    </div>
                </Card>
            </div>
        </>
    );
};

export default DevStatus;